const getStudentDmsEmailConfig = (formData) => {
  const COMMENT = 'оформить полис'
  const PRIVACY = 'согласие получено'
  const PRODUCT = 'Иностранный студент Сеченовского университета'
  const PAGE = window.location.href

  const getLatinStringByKey = (key: string, data: Record<string, unknown>) => {
    const value = data[key]
    const latinValue = data[`${key}Latin`]
    return `${value ?? ''} ${latinValue ? ' / ' + latinValue : ''}`
  }

  const getContact = (data, suffix = '') => {
    const tel = data[`userTel${suffix}`] ?? ''
    const email = suffix === '' ? data.userEmail ?? '' : ''
    return [tel, email].filter(Boolean).join(' / ')
  }

  return {
    surname: getLatinStringByKey('userSurname', formData),
    name: getLatinStringByKey('userName', formData),
    patronymic: getLatinStringByKey('userPatronymic', formData),
    contact: getContact(formData),
    gender: formData.userGender ?? '',
    birthdate: formData.userBirthday ?? '',
    citizenship: formData.userCitizenship ?? '',
    passportSeries: formData.userPassportSeries ?? '',
    passportNumber: formData.userPassportNumber ?? '',
    passportIssueDate: formData.userPassportIssueDate ?? '',
    passportRegistrationAddress:
      formData.userPassportRegistrationAddress?.address ?? '',
    passportCountryOfIssue: formData.userPassportCountryOfIssue ?? '',
    passportUniqueNumber: formData.userPassportUniqueNumber ?? '',
    comment: COMMENT,
    privacy: PRIVACY,
    product: PRODUCT,
    page: PAGE,
  }
}

const getStudentDmsDescriptionText = (config, formData) => {
  let result = `
    Желаемая дата начала действия: ${
      formData.userPoliceEffectiveDate ?? ''
    } <br>
    Фамилия Страхователя: ${config.surname} <br>
    Имя Страхователя: ${config.name} <br>
    Отчество Страхователя: ${config.patronymic} <br>
    Дата Рождения Страхователя: ${config.birthdate} <br>
    Пол Страхователя: ${config.gender} <br>
    Гражданство Страхователя: ${config.citizenship} <br>
    Иностранный паспорт: <br>
    Дата выдачи паспорта Страхователя: ${config.passportIssueDate} <br>
    Серия паспорта Страхователя: ${config.passportSeries} <br>
    Номер паспорта Страхователя: ${config.passportNumber} <br>
    Адрес регистрации в России: ${config.passportRegistrationAddress} <br>
    Номер телефона/e-mail Страхователя: ${config.contact} <br>
  `

  // result += `ID МВД паспорт Страхователя: ${config.passportUniqueNumber} <br>
  //   Тип оплаты: ${formData.userPayment ?? ''} <br>`

  result += `Комментарий: ${config.comment} <br>
    Политика конфиденциальности: ${config.privacy} <br>
    Страница сайта: ${config.page} <br>
    Продукт: ${config.product} <br>`

  return result.trim()
}

const getStudentDmsEngDescriptionText = (config, formData) => {
  return `
    Фамилия Страхователя: ${config.surname} <br>
    Имя Страхователя: ${config.name} <br>
    Отчество Страхователя: ${config.patronymic} <br>
    Номер телефона/e-mail Страхователя: ${config.contact} <br>
    Пол Страхователя: ${config.gender} <br>
    Гражданство Страхователя: ${config.citizenship} <br>
    Дата Рождения Страхователя: ${config.birthdate} <br>
    Иностранный паспорт: <br>
    Серия паспорта Страхователя: ${config.passportSeries} <br>
    Номер паспорта Страхователя: ${config.passportNumber} <br>
    Дата выдачи паспорта Страхователя: ${config.passportIssueDate} <br>
    Адрес регистрации в России: ${config.passportRegistrationAddress} <br>
    Страна выдачи паспорт Страхователя: ${config.passportCountryOfIssue} <br>
    ID МВД паспорт Страхователя: ${config.passportUniqueNumber} <br>
    Тип оплаты: ${formData.userPayment ?? ''} <br>
    Комментарий: ${config.comment} <br>
    Политика конфиденциальности: ${config.privacy} <br>
    Страница сайта: ${config.page} <br>
    Продукт: ${config.product} <br>
  `.trim()
}

export const getStudentDmsEmailDescription = (formData) => {
  const config = getStudentDmsEmailConfig(formData)
  return getStudentDmsDescriptionText(config, formData)
}

export const getStudentDmsEngEmailDescription = (formData) => {
  const config = getStudentDmsEmailConfig(formData)
  return getStudentDmsEngDescriptionText(config, formData)
}

export const getAgentEmailDescription = (formData) => {
  return `
    ФИО: ${formData.userName} <br>
    Рабочий e-mail в домене rgs.ru: ${formData.email} <br>
    Личный Номер Работника (ЛНР): ${formData.lnr} <br>
    Номер телефона: ${formData.phone} <br>
    Город: ${formData.city} <br>
    Адрес: ${formData.address} <br>
  `.trim()
}
